import React from 'react'

export default function SkillQuest() {
  return (
    <section className="relative py-16 px-4 sm:px-6">
      {/* Responsive iframe container */}
      <div className="relative w-full h-[1000px] overflow-hidden">
        <iframe
          src="https://skill-quest--seetah90f.replit.app/?embed=true"
          title="Skill Quest App"
          className="absolute inset-0 w-full h-full border-0"
          allowFullScreen
          loading="lazy"
        />
      </div>
    </section>
  )
}
